
import { computed, defineComponent, ref, Ref, toRef, watch } from 'vue';
import { Field } from 'vee-validate';
import { CustomInputFieldInternalValue } from '@/shared/form/validation.plugin';

export default defineComponent({
    name: 'InputRadio',
    components: { Field },
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
        value: {
            type: [String, Object, Boolean, Number],
            required: false,
            default: '',
        },
        // eslint-disable-next-line vue/require-default-prop
        modelValue: {
            type: null,
        },
        name: {
            type: String,
            required: true,
        },
        showErrors: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        htmlLabel: {
            type: String,
            default: '',
        },
        rules: {
            type: String,
            default: '',
        },
        alignLabelWithTop: {
            type: Boolean,
            default: false,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
    },
    emits: {
        'update:modelValue': (value) => true,
    },
    setup(props, { emit }) {
        const internalValue: Ref<CustomInputFieldInternalValue> = ref(null);

        const fieldId = computed(() => {
            return props.id || props.name + Math.random();
        });

        const fieldRules = computed(() => props.rules);

        const isModelBound = computed(() => {
            return 'modelValue' in props;
        });

        if (isModelBound.value) {
            const modelValue = toRef(props, 'modelValue');
            watch(modelValue, newModelValue => {
                if (newModelValue !== internalValue.value) {
                    internalValue.value = newModelValue;
                }
            }, { immediate: true });
            watch(internalValue, newInternalValue => {
                emit('update:modelValue', newInternalValue);
            });
        }

        return {
            fieldId,
            internalValue,
            fieldRules,
        };
    },
});
